import { useAuth } from "@/contexts/AuthContext";

interface Tenant {
  id: string;
  name: string;
  cnpj?: string | null;
  email?: string | null;
  phone?: string | null;
  onboarding_completed_at?: string | null;
  portal_code?: string | null;
}

interface Profile {
  id: string;
  full_name: string | null;
  tenant_id: string;
}

interface UseTenantResult {
  tenant: Tenant | null;
  profile: Profile | null;
  loading: boolean;
}

export function useTenant(): UseTenantResult {
  const { me, loading } = useAuth();

  if (!me) {
    return { tenant: null, profile: null, loading };
  }

  const tenant: Tenant = {
    id: me.tenant_id,
    name: "",
    cnpj: null,
    email: null,
    phone: null,
    onboarding_completed_at: null,
    portal_code: null,
  };

  const profile: Profile = {
    id: me.id,
    full_name: null,
    tenant_id: me.tenant_id,
  };

  return { tenant, profile, loading };
}
